<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field    
        outlined
        dense
        readonly
        :label="label"
        v-on="on"      
        :value="localValue"
        :error-messages="error"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="localValue"
      @change="save"
      :min="minDate"
      :max="maxDate"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    selectValue: {
      type: String,
      default: '' 
    },
    label: {
      type: String,
      required: true
    },
    error: {
      type: [String, Array],
      default: () => []
    },
    minDate: {
      type: String,
      default: ''
    },
    maxDate: {
      type: String,
      default: ''
    }
  },
  data() {
    return {  
      menu: false,
      localValue: this.selectValue // Use a local data property for v-model binding
    }
  },
  watch: {
    // Watch for changes in selectValue and update localValue accordingly
    selectValue(newVal) {
      this.localValue = newVal;
    }
  },
  methods: {
    save(date) {      
      this.$emit("changeInput", date);    
      this.menu = false;
    }      
  }
}
</script>
